// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Checkbox from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupPresentationProps } from "@insite/mobius/CheckboxGroup";
import constants from "@store/constants";
import setFieldValue from "@store/Framework/Store/Greif/Components/InviteYourColleague/Handlers/SetFieldValue";
import { InviteYourColleagueFormContext } from "@store/Library/Widgets/InviteYourColleague/InviteYourColleagueForm";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    isRequired = "isRequired",
    fieldLabel = "fieldLabel",
    portalInfos = "portalInfos",
    portalInfo = "portalInfo",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.isRequired]: boolean;
        [fields.fieldLabel]: string;
        [fields.portalInfos]: {
            fields: {
                [fields.portalInfo]: string;
            };
        }[];
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    portalInfo: state.greif.components.inviteYourColleagueForm.fieldValues["portalInfo"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface PortalInfoStyles {
    portalInfoCheckboxGroupStyles?: CheckboxGroupPresentationProps;
}

export const portalInfoStyles: PortalInfoStyles = {
    portalInfoCheckboxGroupStyles: {
        css: css`
            legend {
                margin-bottom: ${pxToRem(10)};
            }
        `,
    },
};

const styles = portalInfoStyles;

const PortalInfo: FC<Props> = ({ fields, portalInfo, setFieldValue }) => {
    const { isRequired, fieldLabel, portalInfos } = fields;
    const inviteYourColleagueFormContext = useContext(InviteYourColleagueFormContext);
    const [portalInfoErrorMessage, setPortalInfoErrorMessage] = useState("");
    const [objPortalInfos, setObjPortalInfos] = useState<any[]>(portalInfos);

    useEffect(() => {
        inviteYourColleagueFormContext.validators.portalInfo = validatePortalInfo;
        if (typeof portalInfo !== "undefined" || portalInfo !== "default") {
            validatePortalInfo();
        }
    }, [portalInfo]);

    useEffect(() => {
        inviteYourColleagueFormContext.validators.portalInfo = validatePortalInfo;
    }, [isRequired]);

    useEffect(() => {
        if (portalInfos) {
            const _tempPortalInfos: any[] = [];
            const mimicArr = portalInfo as [];

            portalInfos.forEach((x, index) => {
                const checkSavedValue = mimicArr?.find(o => o === x.fields.portalInfo);
                _tempPortalInfos.push({
                    index,
                    label: x.fields.portalInfo,
                    value: !!checkSavedValue,
                });
            });

            setObjPortalInfos(_tempPortalInfos);
        }
    }, [portalInfos]);

    const validatePortalInfo = () => {
        const errorMessage = isRequired && !portalInfo ? (translate(`${fieldLabel} is required`) as string) : "";
        setPortalInfoErrorMessage(errorMessage);
        return !errorMessage;
    };

    const portalInfoChangeHandler = (value: boolean, index: number) => {
        const _tempPortalInfos = objPortalInfos.map(x => (x.index === index ? { ...x, value: !value } : x));
        setObjPortalInfos(_tempPortalInfos);

        const checkedPortalInfo = _tempPortalInfos.filter(x => x.value).map(x => x.label);
        setFieldValue({ key: "portalInfo", value: checkedPortalInfo });
    };

    return (
        <CheckboxGroup
            // eslint-disable-next-line spire/avoid-dynamic-translate
            label={translate(fieldLabel)}
            required={isRequired}
            error={portalInfoErrorMessage}
            {...styles.portalInfoCheckboxGroupStyles}
        >
            {objPortalInfos.map((x, _) => (
                <Checkbox checked={x.value} key={_} onChange={() => portalInfoChangeHandler(x.value, x.index)}>
                    {
                        // eslint-disable-next-line spire/avoid-dynamic-translate
                        translate(x.label)
                    }
                </Checkbox>
            ))}
        </CheckboxGroup>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(PortalInfo),
    definition: {
        displayName: "Relevant Portal Info",
        group: constants.widgetGroup.inviteYourColleague,
        icon: "input-pipe",
        allowedContexts: [constants.pageType.inviteYourColleague, constants.pageType.notificationPreferences],
        fieldDefinitions: [
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.fieldLabel,
                displayName: "Field Label",
                editorTemplate: "TextField",
                defaultValue: "Portal Information Most Relevant to Your Colleague",
                fieldType: "Translatable",
            },
            {
                name: fields.portalInfos,
                displayName: "Portal Information Options",
                editorTemplate: "ListField",
                getDisplay: item => {
                    return item.fields.portalInfo;
                },
                defaultValue: [
                    {
                        fields: {
                            portalInfo: "Product insights (catalogue, specifications, pricing)",
                        },
                    },
                    {
                        fields: {
                            portalInfo: "Order history, invoices, shipping documents",
                        },
                    },
                    {
                        fields: {
                            portalInfo: "Reports (insights into past and open orders)",
                        },
                    },
                    {
                        fields: {
                            portalInfo: "Placing orders online",
                        },
                    },
                    {
                        fields: {
                            portalInfo: "Other",
                        },
                    },
                ],
                fieldType: "Contextual",
                fieldDefinitions: [
                    {
                        name: "portalInfo",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
